  import detectEnvironment from './enviroments';
  
  const {api, hostname} = detectEnvironment();
  
  console.log('API:', api);
  console.log('Hostname:', hostname);

export default{
    api, hostname,
    config : {headers: {'Bearer ': sessionStorage.token}}
}